import React, { useState, useEffect } from 'react';
import "./DynamicSelect.css";
import data from './symbols_mini.json';
//import Create from './create';

export default function DynamicSelect(props) {
  const [options, setOptions] = useState([
    { value: 'option1', label: 'Option 1' },
  ]);

  useEffect(() => {
    var prep = '';
    {props.search.split('').map((char, index) => (
        prep += document.getElementById('t' + index).value
    ))}
    props.setOutput(prep);
    //console.log(data);
  },[props.search])

  const [selectedValue, setSelectedValue] = useState([]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    //props.search = props.search.substring(0, event.target.id.substring(1)) + event.target.value + props.search.substring((event.target.id.substring(1)+1));
    //console.log(props.search.substring(0, event.target.id.substring(1)) + event.target.value + props.search.substring((event.target.id.substring(1)+1)));
    //props.setOutput(props.search.substring(0, event.target.id.substring(1)) + event.target.value + props.search.substring((event.target.id.substring(1)+1)));
    var prep = '';
    {props.search.split('').map((char, index) => (
      prep += document.getElementById('t' + index).value
    ))}
    props.setSearch(prep);
  }

  return (
    <div>
     {props.search.split('').map((letter, index) => (
    <label key={index}>
      <select key={index} id={'t'+index} value={letter} onChange={handleChange}>
        {data.map((option, dIndex) => (
          <option key={data[dIndex].Char+dIndex} value={data[dIndex].Char}>{data[dIndex].Char}</option>
        ))}
      </select>
      </label>
      ))}
    </div>
  );
}